<template>
  <div class="sidebar">
    <div
      v-for="(item, index) in navItems"
      :key="index"
      class="nav-item"
      :class="{ active: activeIndex === index }"
      @click="setActive(index)"
    >
      {{ item }}
    </div>

    <div style="margin-top: auto">
      <div
        v-for="(item, index) in bottomNavItems"
        :key="`bottom-${index}`"
        class="nav-item"
        :class="{ active: activeIndex === index + navItems.length }"
        @click="setActive(index + navItems.length)"
      >
        {{ item }}
      </div>
    </div>

    <!-- 左侧跟随移动的选择框 -->
    <div class="sidebar-user-menu" :style="{ top: menuTopPosition + 'px' }"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      menuTopPosition: 0,
      navItems: ['智能作业', '智能组卷', '智能批改', '学情分析', ''],
      bottomNavItems: ['学习历史', '我的智能体', '收藏夹']
    }
  },
  methods: {
    setActive(index) {
      this.activeIndex = index

      // 计算选择框应该移动到的位置
      this.$nextTick(() => {
        const navItemElements = document.querySelectorAll('.nav-item')
        if (navItemElements[index]) {
          this.menuTopPosition = navItemElements[index].offsetTop
        }
      })
    }
  }
}
</script>
